import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Composite/Footer/Footer.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Footer';
export {styles};